import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiCommentsSettingsModule } from '@fi-shared/fi-comments/fi-comments-settings';
import { FiCommentLikeButtonsModule } from '@fi-shared/fi-comments/fi-comment-like-buttons/fi-comment-like-buttons.module';
import { FiCommentsService } from '@fi-shared/fi-comments/fi-comments.service';
import { FiCommentsListModule } from '@fi-shared/fi-comments/fi-comments-list/fi-comments-list.module';

@NgModule({
    declarations: [],
    imports: [CommonModule, FiCommentsListModule, FiCommentsSettingsModule, FiCommentLikeButtonsModule],
    providers: [FiCommentsService],
    exports: [FiCommentsListModule, FiCommentsSettingsModule, FiCommentLikeButtonsModule],
})
export class FiCommentsModule {}
